var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgWater = function SvgWater(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect819",
    fill: "currentColor",
    fillOpacity: 0.111,
    d: "M6 1.572c-.273.338-.784.937-1.557 2.077-.48.708-.947 1.489-1.298 2.199S2.58 7.214 2.58 7.604c0 1.883 1.536 3.42 3.42 3.42s3.42-1.537 3.42-3.42c0-.39-.213-1.046-.564-1.756a19 19 0 0 0-1.3-2.2C6.785 2.51 6.274 1.91 6 1.572"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "currentColor",
    d: "m6 0-.382.458s-.977 1.178-1.97 2.641c-.495.733-1.007 1.533-1.388 2.306-.382.772-.657 1.513-.657 2.198C1.603 10.019 3.583 12 6 12s4.397-1.981 4.397-4.397c0-.685-.275-1.426-.657-2.198s-.893-1.573-1.389-2.306C7.359 1.636 6.381.458 6.381.458zm0 1.573c.273.337.784.937 1.557 2.076.481.708.947 1.488 1.298 2.198s.565 1.367.565 1.756A3.426 3.426 0 0 1 6 11.023a3.426 3.426 0 0 1-3.42-3.42c0-.39.214-1.046.565-1.756s.817-1.49 1.298-2.198C5.216 2.509 5.727 1.91 6 1.572zM3.779 7.279A2.45 2.45 0 0 0 6.22 9.72v-.977c-.809 0-1.465-.656-1.465-1.465z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWater);
export default ForwardRef;